@if (error()) {
  <p class="cl-p-regular cl-color-brick">{{ error() }}</p>
}

<table style="table-layout: fixed;" class="cl-table-data">
  <colgroup>
    <col style="width: 100%">
    <col style="width: 110px">
    <col style="width: 160px">
    @if (actionTemplate) { <col style="width: 170px"> }
  </colgroup>
  <thead>
    <tr>
      <th class="cl-table-head cl-p-tiny">Name</th>
      <th class="cl-table-head cl-p-tiny">Size</th>
      <th class="cl-table-head cl-p-tiny">Modified</th>
      @if (actionTemplate) {
        <th class="cl-table-head cl-p-tiny">{{ actionHeader() }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @if (loading()) {
      <tr class="cl-tr-no-data">
        <td colspan="100" style="text-align: center">
          Loading ...<i class="fas fa-spinner fa-spin"></i></td>
      </tr>
    } @else {
      @for (row of rows(); track row.entry.folderId + row.entry.path) {
        <tr [class.folder-row]="row.entry.isDirectory">
          <td [style.padding-left.rem]="row.depth * 1.25">
            @if (row.entry.isDirectory) {
              <a class="cl-a-link" (click)="toggle(row)">
                <i class="fas"
                   [class.fa-chevron-right]="!row.expanded && !row.loading"
                   [class.fa-chevron-down]="row.expanded && !row.loading"
                   [class.fa-spinner]="row.loading"
                   [class.fa-spin]="row.loading"></i>
                {{ row.entry.name }}</a>
              @if (row.error) {
                <small class="cl-color-brick"> — {{ row.error }}</small>
              } @else if (row.empty) {
                <small class="text-muted"> — empty</small>
              }
            } @else {
              {{ row.entry.name }}
            }
          </td>
          <td>{{ row.entry.isDirectory ? '—' : (row.entry.size | fileSize) }}</td>
          <td class="cl-td-date"><span class="cl-font-monospace">{{ row.entry.modifiedAt ? (row.entry.modifiedAt | cldate) : '—' }}</span></td>
          @if (actionTemplate) {
            <td class="cl-td-links" width="1%">
              @if (!row.entry.isDirectory) {
                <ng-container
                  [ngTemplateOutlet]="actionTemplate"
                  [ngTemplateOutletContext]="{$implicit: row.entry}"></ng-container>
              }
            </td>
          }
        </tr>
      }
      @if (noSession() && rows().length === 0) {
        <!-- null (not empty) means the API could not list: no session -->
        <tr><td colspan="100">Log in to this portal to browse its files.</td></tr>
      } @else if (rows().length === 0) {
        <tr><td colspan="100">This portal exposes no files.</td></tr>
      }
    }
  </tbody>
</table>
